function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { AnimationTypes, LayerContextType, Layers } from './constants';
import { Gateway, GatewayRegistry } from 'react-gateway';
import PropTypes from 'prop-types';
import React from 'react';
import { getZIndexFromLayer } from './utils';
import invariant from 'invariant';
export var LayerContext =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LayerContext, _React$PureComponent);

  function LayerContext() {
    _classCallCheck(this, LayerContext);

    return _possibleConstructorReturn(this, _getPrototypeOf(LayerContext).apply(this, arguments));
  }

  _createClass(LayerContext, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        currentLayerContext: this.props.layer,
        currentLayerZIndex: getZIndexFromLayer(this.props.layer)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          layer = _this$props.layer,
          props = _objectWithoutProperties(_this$props, ["children", "layer"]); // eslint-disable-line no-unused-vars


      return React.cloneElement(children, props);
    }
  }]);

  return LayerContext;
}(React.PureComponent);

_defineProperty(LayerContext, "childContextTypes", {
  currentLayerContext: LayerContextType,
  currentLayerZIndex: PropTypes.number
});

export default function renderOnLayer(layer, WrappedComponent) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$AnimationType = _ref.AnimationType,
      AnimationType = _ref$AnimationType === void 0 ? AnimationTypes.Slide : _ref$AnimationType;

  invariant(Object.values(Layers).includes(layer), 'You must provide a target that is in the registry.');

  var GatewayWrapped =
  /*#__PURE__*/
  function (_React$PureComponent2) {
    _inherits(GatewayWrapped, _React$PureComponent2);

    function GatewayWrapped() {
      _classCallCheck(this, GatewayWrapped);

      return _possibleConstructorReturn(this, _getPrototypeOf(GatewayWrapped).apply(this, arguments));
    }

    _createClass(GatewayWrapped, [{
      key: "render",
      value: function render() {
        var Animation = this.props.animation;
        var content;

        if (Animation !== AnimationTypes.Custom && Object.values(AnimationTypes).includes(Animation)) {
          var _this$props2 = this.props,
              inProp = _this$props2.in,
              enter = _this$props2.enter,
              exit = _this$props2.exit,
              onExited = _this$props2.onExited,
              animationOptions = _this$props2.animationOptions,
              props = _objectWithoutProperties(_this$props2, ["in", "enter", "exit", "onExited", "animationOptions"]);

          content = React.createElement(Animation, {
            in: inProp,
            enter: enter,
            exit: exit,
            onExited: onExited,
            animationOptions: animationOptions
          }, React.createElement(WrappedComponent, props));
        } else {
          content = React.createElement(WrappedComponent, this.props);
        }

        return React.createElement(Gateway, {
          into: layer
        }, React.createElement(LayerContext, {
          layer: layer
        }, content));
      }
    }]);

    return GatewayWrapped;
  }(React.PureComponent);

  _defineProperty(GatewayWrapped, "contextTypes", {
    gatewayRegistry: PropTypes.instanceOf(GatewayRegistry)
  });

  _defineProperty(GatewayWrapped, "defaultProps", {
    animation: AnimationType
  });

  var name = WrappedComponent.displayName || WrappedComponent.name;
  GatewayWrapped.displayName = "GatewayWrapped(".concat(name, ")");
  return GatewayWrapped;
}